export default "__VITE_ASSET__BQZ3H9PS__"